define('SuiteDynamics.Item.KeyMapping.Extended',
    ['Item.KeyMapping', 'SC.Configuration', 'underscore', 'Utils'],
    function (ItemKeyMapping, Configuration, _, Utils)
{
    'use strict';

    ItemKeyMapping.getKeyMapping = _.wrap(ItemKeyMapping.getKeyMapping, function wrappedGetKeyMapping (fn, configuration) {
        var originalKeyMappingReturn;

        originalKeyMappingReturn = fn.apply(this, Array.prototype.slice.call(arguments, 1));

        return _.extend(originalKeyMappingReturn, {
            _thumbnail: function(item) {
                var item_images_detail = item.get('itemimages_detail') || {};
                var infographicsKey = Configuration.get('imageGalleryGrid.infographicsImageKey', 'infographics');

                var filteredImages = _.filter(Utils.imageFlatten(item_images_detail), function (image) {
                 return image.url && image.url.toLowerCase().indexOf(infographicsKey.toLowerCase()) === -1;
                });

                // If you generate a thumbnail position in the itemimages_detail it will be used
                if (item_images_detail.thumbnail) {
                 if (
                     _.isArray(item_images_detail.thumbnail.urls) &&
                     item_images_detail.thumbnail.urls.length
                 ) {
                     return item_images_detail.thumbnail.urls[0];
                 }

                 return item_images_detail.thumbnail;
                }

                // otherwise it will try to use the storedisplaythumbnail
                if (
                 SC.ENVIRONMENT.siteType &&
                 SC.ENVIRONMENT.siteType === 'STANDARD' &&
                 item.get('storedisplaythumbnail')
                ) {
                 return {
                     url: item.get('storedisplaythumbnail'),
                     altimagetext: item.get('_name')
                 };
                }
                // No images huh? carry on

                var parent_item = item.get('_matrixParent');
                // If the item is a matrix child, it will return the thumbnail of the parent
                if (parent_item && parent_item.get('internalid')) {
                 return parent_item.get('_thumbnail');
                }

                // If you using the advanced images features it will grab the 1st valid one
                if (filteredImages.length) {
                 for (var i = 0; i < filteredImages.length; i++) {
                     var detail = filteredImages[i];
                     var splitted = detail.url.split('.');
                     if (splitted[splitted.length - 2] === 'default') {
                         return detail;
                     }
                 }
                 return filteredImages[0];
                }

                // still nothing? image the not available
                return {
                 url: Utils.getThemeAbsoluteUrlOfNonManagedResources(
                     'img/no_image_available.jpeg',
                     configuration.get('imageNotAvailable')
                 ),
                 altimagetext: item.get('_name')
                };
            }
        });
    });
 });
